export default "assets/images/logo-034d1fec.png";